
export default function generateFilterForQuery(filterOptions: any) {

    const filter: any[] = [
        // { $null: [ 'products.archived_at' ] },
        // { $null: [ 'product_containers.archived_at' ] },
    ];

    if (filterOptions.clientId) {
        filter.push({ "$eq": ["client_product_containers.client_id", {"$": filterOptions.clientId}] })
    }

    if (filterOptions.product_name) {
        filter.push({ "$ilike": ["products.name", {"$": `%${filterOptions.product_name}%`}] })
    }

    if (filterOptions.container_name) {
        filter.push({ "$ilike": ["product_containers.name", {"$": `%${filterOptions.container_name}%`}] })
    }
    if (filterOptions.view && filterOptions.view !== 'all') {
      if (['active'].includes(filterOptions.view)) {
        filter.push({"$null": ["products.archived_at"]})
        filter.push({"$null": ["product_containers.archived_at"]})
        filter.push({ "$eq": ["client_product_containers.hidden", {"$": false}] })
      }
      if (['archived'].includes(filterOptions.view)) {
        filter.push({"$or": [
            {"$not": [{"$null": ["products.archived_at"]}]},
            {"$not": [{"$null": ["product_containers.archived_at"]}]}
        ]})
      }

      if (['hidden'].includes(filterOptions.view)) {
        filter.push({ "$eq": ["client_product_containers.hidden", {"$": true}] })
        filter.push({"$null": ["products.archived_at"]})
        filter.push({"$null": ["product_containers.archived_at"]})
      }
    }

    return filter;
}

export class PriceListListPageQuery {

  static build(query: any, pathData: any = {}) {

    const filter = generateFilterForQuery(query);

    return {
      columns: PriceListListPageQuery.COLUMNS,
      from: PriceListListPageQuery.FROM,
      from_as: PriceListListPageQuery.FROM_AS,
      joins: PriceListListPageQuery.JOINS,
      page_size: PriceListListPageQuery.PAGE_SIZE,
      ...({page: parseInt(query.page) || 1}),
      ...({
          order: [
              { $asc: [ PriceListListPageQuery.COLUMNS['hidden']] },
              { $asc: [ PriceListListPageQuery.COLUMNS['product_name']] },
              query.sortDirection == 'desc' ? { $desc: [PriceListListPageQuery.COLUMNS[query.sortField || 'container_name' ]] } : { $asc: [PriceListListPageQuery.COLUMNS[query.sortField || 'container_name']] }
          ]
      }),
      order: [
          {$desc: ['products.archived_at']},
          {$desc: ['product_containers.archived_at']},
          {$asc: ['products.name']},
          {$asc: ['product_containers.name']},
      ],
      ...(
          filter.length > 1 ?
          {
              "where": {
                  "$and": filter
              }
          } : {
              "where": filter[0]
          }
      ),
      ...pathData
    }
  }

  static COLUMNS: any = {
    id: 'client_product_containers.id',
    container_price: 'client_product_containers.container_price',
    hidden: 'client_product_containers.hidden',
    hidden_date: 'client_product_containers.hidden_date',
    is_recomended: 'client_product_containers.is_recomended',

    product_id: 'products.id',
    product_name: 'products.name',
    product_archived_at: 'products.archived_at',
    container_id: 'product_containers.id',
    container_name: 'product_containers.name',
    container_archived_at: 'product_containers.archived_at',
  };

  static FROM: string = 's:products';
  static FROM_AS: string = 'products';

  static JOINS: any[] = [
    {
        join: 's:product_containers',
        as:   'product_containers',
        on: {
            $eq: ['product_containers.product_id', 'products.id']
        }
    },
    {
        join: 's:client_product_containers',
        as:   'client_product_containers',
        on: {
            $eq: ['client_product_containers.product_container_id', 'product_containers.id']
        }
    },
  ]

//   static GROUPS: any[] = [
//     'deal.id', 'deal.expected_delivery_date', 'deal.name',
//     'pipe.name', 'status.id', 'status.name', 'client.name', 'counterparty.name', 'city.name',
//     'point.address', 'manager.name', 'create_by_people.id'
//   ]

  static PAGE_SIZE: number = 15

}